var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 27.8428H6.14453C5.88242 27.8428 5.63105 27.7387 5.44571 27.5533C5.26037 27.368 5.15625 27.1166 5.15625 26.8545V15.9834C5.15625 14.426 5.463 12.8838 6.05899 11.445C6.65498 10.0062 7.52853 8.69879 8.62977 7.59755C9.73102 6.4963 11.0384 5.62275 12.4772 5.02676C13.9161 4.43077 15.4582 4.12402 17.0156 4.12402H17.0156C18.573 4.12402 20.1152 4.43078 21.554 5.02676C22.9929 5.62275 24.3002 6.49631 25.4015 7.59755C26.5027 8.6988 27.3763 10.0062 27.9723 11.445C28.5682 12.8839 28.875 14.426 28.875 15.9834V15.9834C28.875 19.1287 27.6255 22.1452 25.4015 24.3692C23.1774 26.5933 20.1609 27.8428 17.0156 27.8428Z",
    stroke: "#3A3A3A",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 18.5625C18.1547 18.5625 19.0781 17.6391 19.0781 16.5C19.0781 15.3609 18.1547 14.4375 17.0156 14.4375C15.8765 14.4375 14.9531 15.3609 14.9531 16.5C14.9531 17.6391 15.8765 18.5625 17.0156 18.5625Z",
    fill: "#3A3A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2031 18.5625C24.3422 18.5625 25.2656 17.6391 25.2656 16.5C25.2656 15.3609 24.3422 14.4375 23.2031 14.4375C22.064 14.4375 21.1406 15.3609 21.1406 16.5C21.1406 17.6391 22.064 18.5625 23.2031 18.5625Z",
    fill: "#3A3A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8281 18.5625C11.9672 18.5625 12.8906 17.6391 12.8906 16.5C12.8906 15.3609 11.9672 14.4375 10.8281 14.4375C9.68904 14.4375 8.76562 15.3609 8.76562 16.5C8.76562 17.6391 9.68904 18.5625 10.8281 18.5625Z",
    fill: "#3A3A3A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSymbol);
export default __webpack_public_path__ + "static/media/messageSymbol.699eef24fe1fba4fe0b7b5df1be06eb9.svg";
export { ForwardRef as ReactComponent };